<div #wrapped class="wrapped">
  <ng-content> </ng-content>
</div>
